"use client";
import { useEffect, useState } from "react";
import { Direction, NavigationArrow } from "./navigation-arrow";

export interface NavigationArrowWrapperProps {}

// Hook to track the percent a user has scrolled through the page
// TODO: turn this into a context
function useScrollPercent() {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const currentPosition = window.scrollY;
      const innerHeight = document.documentElement.clientHeight;
      const docHeight = document.body.offsetHeight;
      const scrollPercent = (100 * currentPosition) / (docHeight - innerHeight);
      setScroll(scrollPercent);
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  return scroll;
}

export const NavigationArrowWrapper = (_props: NavigationArrowWrapperProps) => {
  const scrollPercent = useScrollPercent();

  // Scroll down until we're very close to the bottom of the page
  const variant = scrollPercent < 99 ? Direction.Down : Direction.Up;
  // Scroll up or down, depending on the variant
  const scrollY = () =>
    variant === Direction.Down
      ? Math.min(document.body.offsetHeight, window.scrollY + 600)
      : 0;

  return (
    <NavigationArrow
      variant={variant}
      // Scroll onClick
      onClick={() => {
        typeof window !== "undefined" &&
          window.scrollTo(window.scrollX, scrollY());
      }}
      position="fixed"
      bottom="1rem"
      right="1rem"
      colorScheme="blue"
      zIndex={10}
    />
  );
};
